import { WorkIntegration_Keys } from '@/common/api/types/workIntegrations';

export const buildSourceItemLink = (
  sourceSystemType: string | undefined,
  instanceUrl: string | undefined,
  projectId: string | undefined,
  sourceItemKey: string | null | undefined,
): string | null => {
  if (!sourceItemKey || !instanceUrl) return null;
  if (sourceSystemType === WorkIntegration_Keys.JIRA) {
    return `${instanceUrl}/browse/${sourceItemKey}`;
  }
  if (sourceSystemType === WorkIntegration_Keys.ADO && projectId) {
    return `${instanceUrl}/${encodeURIComponent(projectId)}/_workitems/edit/${sourceItemKey}`;
  }
  return null;
};
